/**
 * API処理結果コード
 */
export var ApiResultCodes;

(function (ApiResultCodes) {
  /**
   * 無し
   */
  ApiResultCodes[ApiResultCodes["None"] = 0] = "None";
  /**
   * 正常
   */

  ApiResultCodes[ApiResultCodes["Success"] = 1] = "Success";
  /**
   * 対象データが別ユーザーにより変更されていることを表す
   */

  ApiResultCodes[ApiResultCodes["UpdateDateRetrieved"] = 201] = "UpdateDateRetrieved";
  /**
   * 他のデータと重複していることを表す
   */

  ApiResultCodes[ApiResultCodes["UniqueIndexViolation"] = 202] = "UniqueIndexViolation";
  /**
  * 会議のストレージ不足
  */

  ApiResultCodes[ApiResultCodes["SessionStorageShortage"] = 203] = "SessionStorageShortage";
  /**
  * サポートしていないデータ型
  */

  ApiResultCodes[ApiResultCodes["UnsupportedDataType"] = 204] = "UnsupportedDataType";
  /**
  * 既に登録済み
  */

  ApiResultCodes[ApiResultCodes["AlreadyRegistered"] = 205] = "AlreadyRegistered";
  /**
  * ユーザー超過
  */

  ApiResultCodes[ApiResultCodes["UsersExceeded"] = 206] = "UsersExceeded";
  /**
  * ゲスト超過
  */

  ApiResultCodes[ApiResultCodes["GuestsExceeded"] = 207] = "GuestsExceeded";
  /**
  * 検証エラー
  */

  ApiResultCodes[ApiResultCodes["ValidationError"] = 208] = "ValidationError";
  /**
   * 形式エラー
   */

  ApiResultCodes[ApiResultCodes["FormatError"] = 209] = "FormatError";
  /**
  * ロックアウト
  */

  ApiResultCodes[ApiResultCodes["LockedOut"] = 210] = "LockedOut";
  /**
   * 文字数エラー
   */

  ApiResultCodes[ApiResultCodes["LengthError"] = 211] = "LengthError";
})(ApiResultCodes || (ApiResultCodes = {}));